export { colors } from './colors';
export { typography } from './typography';

export type { Colors } from './colors';
export type { Typography } from './typography';
